/**
 * Inspection photo uploads — drag-and-drop + click-to-browse.
 *
 * Looks for [data-photo-uploader] cards with data-upload-url attribute.
 * Handles two states:
 *   - Empty: file-uploader dropzone (drag-and-drop area)
 *   - Populated: photo-grid with a dashed + button
 * Transitions from empty → populated on first upload.
 */

(function () {

    function getCsrfToken() {
        return window._cc && window._cc.getCsrfToken ? window._cc.getCsrfToken() : '';
    }

    function initPhotoUploader(card) {
        if (!card || card.hasAttribute('data-photo-init')) return;
        card.setAttribute('data-photo-init', '');

        var uploadUrl = card.getAttribute('data-upload-url');
        var fileInput = card.querySelector('.file-uploader-input');

        if (!fileInput || !uploadUrl) return;

        // Click-to-browse: any [data-photo-add] element triggers file picker
        card.addEventListener('click', function (e) {
            var addBtn = e.target.closest('[data-photo-add]');
            if (addBtn) {
                e.preventDefault();
                fileInput.click();
            }
        });

        fileInput.addEventListener('change', function () {
            for (var i = 0; i < fileInput.files.length; i++) {
                uploadFile(uploadUrl, fileInput.files[i], card);
            }
            fileInput.value = '';
        });

        // Drag-and-drop on the card body
        var body = card.querySelector('.card__body');
        var dragCounter = 0;

        body.addEventListener('dragenter', function (e) {
            e.preventDefault();
            dragCounter++;
            var dz = card.querySelector('.file-uploader-dropzone');
            if (dz) dz.classList.add('file-uploader-dropzone-active');
        });

        body.addEventListener('dragover', function (e) {
            e.preventDefault();
        });

        body.addEventListener('dragleave', function () {
            dragCounter--;
            if (dragCounter === 0) {
                var dz = card.querySelector('.file-uploader-dropzone');
                if (dz) dz.classList.remove('file-uploader-dropzone-active');
            }
        });

        body.addEventListener('drop', function (e) {
            e.preventDefault();
            dragCounter = 0;
            var dz = card.querySelector('.file-uploader-dropzone');
            if (dz) dz.classList.remove('file-uploader-dropzone-active');
            for (var i = 0; i < e.dataTransfer.files.length; i++) {
                uploadFile(uploadUrl, e.dataTransfer.files[i], card);
            }
        });
    }

    function ensureGrid(card) {
        var grid = card.querySelector('.photo-grid');
        if (grid) return grid;

        // Transition from empty state to photo-grid
        var body = card.querySelector('.card__body');
        var wrapper = card.querySelector('[data-photo-grid]');
        var newGrid = document.createElement('div');
        newGrid.className = 'photo-grid photo-grid--lg photo-grid--edit';
        newGrid.setAttribute('data-photo-grid', '');

        // Add the "+" button
        var addBtn = document.createElement('button');
        addBtn.type = 'button';
        addBtn.className = 'photo-grid__add';
        addBtn.setAttribute('data-photo-add', '');
        addBtn.innerHTML = '<i class="fa-solid fa-plus"></i>';
        newGrid.appendChild(addBtn);

        if (wrapper) {
            wrapper.replaceWith(newGrid);
        } else {
            body.insertBefore(newGrid, body.querySelector('.file-uploader-input'));
        }

        return newGrid;
    }

    function uploadFile(url, file, card) {
        var formData = new FormData();
        formData.append('photos', file);

        var xhr = new XMLHttpRequest();
        xhr.open('POST', url);
        xhr.setRequestHeader('X-CSRFToken', getCsrfToken());
        xhr.onload = function () {
            if (xhr.status >= 200 && xhr.status < 300 && xhr.responseText.trim()) {
                var grid = ensureGrid(card);
                var addBtn = grid.querySelector('.photo-grid__add');
                // Insert new photo(s) before the + button
                if (addBtn) {
                    addBtn.insertAdjacentHTML('beforebegin', xhr.responseText);
                } else {
                    grid.insertAdjacentHTML('beforeend', xhr.responseText);
                }

                // Update badge count
                var badge = card.querySelector('.card__title .badge');
                var count = grid.querySelectorAll('.photo-grid__item').length;
                if (badge) {
                    badge.textContent = count;
                } else {
                    var title = card.querySelector('.card__title');
                    if (title) {
                        title.insertAdjacentHTML('beforeend',
                            ' <span class="badge badge-sm badge-soft-neutral">' + count + '</span>');
                    }
                }

                // Process HTMX attributes and SeeMe dropdowns on new items
                if (window.htmx) htmx.process(grid);
                if (window.SeeMe && SeeMe.dropdown && SeeMe.dropdown.init) SeeMe.dropdown.init();

                if (window.SeeMe && SeeMe.toast) SeeMe.toast.success('Photo uploaded');
            } else {
                if (window.SeeMe && SeeMe.toast) SeeMe.toast.error('Upload failed');
            }
        };
        xhr.onerror = function () {
            if (window.SeeMe && SeeMe.toast) SeeMe.toast.error('Upload failed');
        };
        xhr.send(formData);
    }

    var observer = new MutationObserver(function () {
        document.querySelectorAll('[data-photo-uploader]').forEach(initPhotoUploader);
    });
    observer.observe(document.body, { childList: true, subtree: true });

})();
